import { render, staticRenderFns } from "./EditFieldLaborRevenueRates.vue?vue&type=template&id=b54dec40&scoped=true"
import script from "./EditFieldLaborRevenueRates.vue?vue&type=script&lang=js"
export * from "./EditFieldLaborRevenueRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54dec40",
  null
  
)

export default component.exports